import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ArrayElementType } from "#shared/helpers/ArrayElementType";
import { FilterQuery } from "shared";

export type QuoteRequestLinesSimilarPartsDto = ClientInferResponseBody<
  typeof contract.quoteRequestLines.searchSimilarParts,
  200
>;

export type QuoteRequestLinesSimilarPartDto = ArrayElementType<QuoteRequestLinesSimilarPartsDto>;

export const searchQuoteRequestLineSimilarParts = async ({
  id,
  filterParams,
  limit,
}: {
  id: string | undefined;
  filterParams: FilterQuery;
  limit?: number;
}): Promise<QuoteRequestLinesSimilarPartsDto> => {
  if (!id) {
    return [];
  }

  const response = await api.quoteRequestLines.searchSimilarParts.query({
    params: { id },
    query: { ...filterParams, limit },
    timeout: 30000,
  });

  if (response.status === 200) {
    return response.body;
  }

  return [];
};
